import { render, staticRenderFns } from "./FurnacePowerFailureList.vue?vue&type=template&id=9980b3ea&"
import script from "./FurnacePowerFailureList.vue?vue&type=script&lang=js&"
export * from "./FurnacePowerFailureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports